import { Box, Grid2, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as Haley } from "../../../assets/images/OnBoardingHaley.svg";
import CommonButton from "../../../component/Button";
import {
  CommonGrid2,
  TabPanelView,
} from "../../common-components/StyledComponents";
import { HaileyText } from "../style";
import { TabContext } from "@mui/lab";
import QuickMatchDemo from "./QuickMatchDemo";
import { StyledLinearContainer } from "../../matches/quick-match/components/StyledComponent";
import CommonLinearProgress from "../../../component/Linearprogress";
import FileUpload from "../../matches/quick-match/components/FileUpload";
import { ReactComponent as FirstHaley } from "../../../assets/images/FirstHaley.svg";

const useTypingEffect = (text, speed = 30, shouldStart = true) => {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    if (!shouldStart) {
      setDisplayedText("");
      return;
    }

    let index = 0;
    const timer = setInterval(() => {
      setDisplayedText((prev) => {
        if (index < text.length) {
          const nextChar = text.charAt(index);
          index++;
          return prev + nextChar;
        } else {
          clearInterval(timer);
          return prev;
        }
      });
    }, speed);

    return () => clearInterval(timer);
  }, [text, speed, shouldStart]);

  return displayedText;
};

export default function QuickMatch({
  handleDemoBack,
  quickMatchValue,
  handleClickDemo,
  handleFileUpload,
  handleDeleteFile,
  files,
  isDragging,
  handleDragOver,
  handleDragLeave,
  handleDrop,
  handlJDUploadClick,
  isLoading,
  handleCandidateDragOver,
  handleCandidateDragLeave,
  handleCandidateDrop,
  handleCandidateFileUpload,
  isCandidateDragging,
  candidateFiles,
  handleCandidateDeleteFile,
  handlResumeUploadClick,
  list,
  handleClickSample,
}) {
  const description =
    "Welcome to our guided tutorial. Do you have a Job Description and relevant Candidate resumes to test ? If not you can use with sample JD & Resumes.";
  const description_upload =
    "Welcome to our guided tutorial. Click the upload button to upload a Job Description.";
  const description_upload_resume =
    "Click the upload button to upload a Candidate Resumes.";
  const description_generate =
    "Good Job ! Now click on the generate report button to generate the report";
  const typedText = useTypingEffect(description, 30, quickMatchValue === 0);
  const typedText_upload = useTypingEffect(
    description_upload,
    30,
    quickMatchValue === 1
  );
  const typedText_upload_resume = useTypingEffect(
    description_upload_resume,
    30,
    quickMatchValue === 2
  );

  const typedText_generate = useTypingEffect(
    description_generate,
    30,
    files.length !== 0 || candidateFiles.length !== 0
  );

  return (
    <Box height={"100%"}>
      <TabContext value={quickMatchValue}>
        <TabPanelView value={0} padding="0px" height="100%">
          <CommonGrid2 size={12}>
            <CommonGrid2
              display={"flex"}
              container
              justifyContent={"space-between"}
            >
              <Typography variant="h1" fontSize={"32px"}>
                Quick Match Demo
              </Typography>
              <CommonButton
                value={"Back"}
                padding={"10px 3rem"}
                fontWeight={"700"}
                fontSize={"15px"}
                onClick={() => handleDemoBack("demo", "")}
                disabled={isLoading}
              />
            </CommonGrid2>
            <Typography
              variant="h3"
              fontWeight={300}
              color="#5B738B"
              marginTop={"1.5rem"}
            >
              Just click the relevant button to get started.{" "}
            </Typography>
          </CommonGrid2>
          <CommonGrid2
            display={"flex"}
            alignItems={"end"}
            height={"auto"}
            justifyContent={"end"}
            width={"100%"}
            marginTop={"2rem"}
          >
            <HaileyText
              width={"100%"}
              right="14%"
              customStyle={{
                position: "relative",
                right: "auto !important",
                bottom: "auto !important",
              }}
            >
              <Typography fontWeight={700} color="#883FDD">
                <Typography
                  variant="span"
                  fontWeight={700}
                  fontSize={"20px"}
                  sx={{
                    background:
                      "linear-gradient(98.47deg, #5A35B2 1.87%, #FA4F96 54.6%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  Hi, I am Hailey !
                </Typography>
                <Typography
                  color="#A9B4BE"
                  variant="span"
                  marginLeft={"10px"}
                  fontSize={"18px"}
                >
                  I am your Hiring Assistant
                </Typography>
              </Typography>

              <Typography marginTop={"8px"} fontSize={"17px"} lineHeight={1.7}>
                {typedText}
              </Typography>
            </HaileyText>
          </CommonGrid2>
          <CommonGrid2
            container
            spacing={4}
            marginTop={"2rem"}
            size={12}
            flex={1}
            justifyContent={"space-between"}
            height={"calc(100vh - 22.5rem)"}
            alignItems={"center"}
          >
            <CommonGrid2
              display={"flex"}
              flexDirection={"column"}
              gap={"1.5rem"}
              size={8}
            >
              <CommonButton
                value={"I have a JD and Resumes"}
                padding={"12px 3rem"}
                fontWeight={"700"}
                fontSize={"15px"}
                onClick={() => handleClickDemo("customer_upload")}
                disabled={isLoading}
              />
              <CommonGrid2
                display={"flex"}
                flexDirection={"column"}
                gap={"0px"}
              >
                <CommonButton
                  value={"Use with Sample Job Description and Resumes"}
                  padding={"12px 3rem"}
                  fontWeight={"700"}
                  fontSize={"15px"}
                  variant="outlined"
                  color={"#344054"}
                  border={"#D0D5DD"}
                  onClick={() => handleClickSample("quick_match")}
                  disabled={isLoading}
                  loading={isLoading}
                />
                {list && list.progress > 0 && (
                  <Grid2 size={12} marginBottom={"-1rem"} marginTop={"0.5rem"}>
                    <StyledLinearContainer>
                      <CommonLinearProgress
                        variant={
                          list.progress && !list.visible
                            ? "buffer"
                            : "determinate"
                        }
                        value={list.progress}
                        valueBuffer={list.buffer}
                        height={"8px"}
                        borderRadius={"2px"}
                        backgroundColor={"#E0E0E0"}
                        barbackgroundColor={list.visible ? "red" : "#7F56D9"}
                        dashedmarginTop={"2px"}
                        dashedbackgroundImage={
                          list.visible
                            ? "radial-gradient(rgb(255 46 0) 0%, rgb(255 0 0) 16%, #00000000 42%)"
                            : "radial-gradient(rgb(82 0 255) 0%, rgb(82 0 255) 16%, #00000000 42%)"
                        }
                      />

                      <Typography
                        color="#344054"
                        fontSize={"14px"}
                        fontWeight={500}
                      >
                        {list.progress}%
                      </Typography>
                    </StyledLinearContainer>
                  </Grid2>
                )}
              </CommonGrid2>
              <CommonButton
                value={"Skip Demo"}
                padding={"10px 5rem"}
                fontWeight={"700"}
                fontSize={"15px"}
                background={"transparent"}
                boxShadow={"none"}
                color="#6941C6"
                customStyle={{
                  "&:hover": {
                    boxShadow: "none",
                  },
                }}
                disabled={isLoading}
                onClick={() => handleDemoBack("demo", "")}
              />
            </CommonGrid2>
            <CommonGrid2
              display={"flex"}
              alignItems={"end"}
              height={"100%"}
              size={4}
              justifyContent={"end"}
              position="relative"
            >
              <FirstHaley style={{ flex: 1, height: "100%" }} />
            </CommonGrid2>
            {/* <CommonGrid2
              display={"flex"}
              alignItems={"end"}
              height={"100%"}
              size={5}
              justifyContent={"end"}
              position="relative"
            >
              <HaileyText>
                <Typography fontWeight={700} color="#883FDD">
                  <Typography
                    variant="span"
                    fontWeight={700}
                    fontSize={"18px"}
                    sx={{
                      background:
                        "linear-gradient(98.47deg, #5A35B2 1.87%, #FA4F96 54.6%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Hi, I am Hailey !
                  </Typography>
                  <Typography
                    color="#A9B4BE"
                    variant="span"
                    marginLeft={"10px"}
                    fontSize={"18px"}
                  >
                    I am your Hiring Assistant
                  </Typography>
                </Typography>

                <Typography marginTop={"8px"} fontSize={"15px"}>
                  {typedText}
                </Typography>
              </HaileyText>
              <Haley />
            </CommonGrid2> */}
          </CommonGrid2>
        </TabPanelView>
        <TabPanelView value={1} padding="0px" height="100%">
          <CommonGrid2 size={12}>
            <CommonGrid2
              display={"flex"}
              container
              justifyContent={"space-between"}
            >
              <Typography variant="h1" fontSize={"32px"}>
                Quick Match Demo
              </Typography>
              <CommonButton
                value={"Back"}
                disabled={isLoading}
                padding={"10px 3rem"}
                fontWeight={"700"}
                fontSize={"15px"}
                onClick={() => handleDemoBack("quick_match", 0)}
              />
            </CommonGrid2>
            <Typography
              variant="h3"
              fontWeight={300}
              color="#5B738B"
              marginTop={"1.5rem"}
            >
              Just click the button to upload a job description and get started.
            </Typography>
          </CommonGrid2>
          <CommonGrid2
            container
            spacing={4}
            marginTop={"2rem"}
            size={12}
            flex={1}
            justifyContent={"space-between"}
            height={"calc(100% - 6rem)"}
          >
            <CommonGrid2
              display={"flex"}
              flexDirection={"column"}
              gap={"1.5rem"}
              size={7}
            >
              <Grid2 size={10} margin={"2rem auto 0px"}>
                <Typography
                  fontSize={"14px"}
                  fontWeight={500}
                  marginBottom={2}
                  color="#344054"
                >
                  {"Job Description"}
                </Typography>
                <FileUpload
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  onChange={handleFileUpload}
                  isDragging={isDragging}
                  files={files}
                  handleDeleteFile={handleDeleteFile}
                  disabled={isLoading}
                />
                <CommonButton
                  width={"100%"}
                  variant="contained"
                  color="white"
                  background="#7F56D9"
                  fontWeight="600"
                  value={
                    files.length === 0
                      ? "Upload Job Description"
                      : "Generate Report"
                  }
                  padding={"10px 0px"}
                  onClick={handlJDUploadClick}
                  disabled={isLoading || files.length === 0}
                  loading={isLoading}
                />
                <CommonButton
                  width={"100%"}
                  value={"Skip Demo"}
                  padding={"10px 5rem"}
                  margin={"1.5rem 0px 0px"}
                  fontWeight={"700"}
                  fontSize={"15px"}
                  background={"transparent"}
                  boxShadow={"none"}
                  color="#6941C6"
                  disabled={isLoading}
                  customStyle={{
                    "&:hover": {
                      boxShadow: "none",
                    },
                  }}
                  onClick={() => handleDemoBack("demo", "")}
                />
              </Grid2>
            </CommonGrid2>
            <CommonGrid2
              display={"flex"}
              alignItems={"end"}
              height={"100%"}
              size={5}
              justifyContent={"end"}
              position="relative"
            >
              <HaileyText>
                <Typography fontWeight={700} color="#883FDD">
                  <Typography
                    variant="span"
                    fontWeight={700}
                    fontSize={"18px"}
                    sx={{
                      background:
                        "linear-gradient(98.47deg, #5A35B2 1.87%, #FA4F96 54.6%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Hi, I am Hailey !
                  </Typography>
                </Typography>

                <Typography marginTop={"8px"} fontSize={"15px"}>
                  {files.length !== 0 ? typedText_generate : typedText_upload}
                </Typography>
              </HaileyText>
              <Haley />
            </CommonGrid2>
          </CommonGrid2>
        </TabPanelView>
        <TabPanelView value={2} padding="0px" height="100%">
          <CommonGrid2 size={12}>
            <CommonGrid2
              display={"flex"}
              container
              justifyContent={"space-between"}
            >
              <Typography variant="h1" fontSize={"32px"}>
                Quick Match Demo
              </Typography>
              <CommonButton
                value={"Back"}
                disabled={isLoading}
                padding={"10px 3rem"}
                fontWeight={"700"}
                fontSize={"15px"}
                onClick={() => handleDemoBack("quick_match", 0)}
              />
            </CommonGrid2>
            <Typography
              variant="h3"
              fontWeight={300}
              color="#5B738B"
              marginTop={"1.5rem"}
            >
              Just click the button to upload a resume and get started.
            </Typography>
          </CommonGrid2>
          <CommonGrid2
            container
            spacing={4}
            marginTop={"2rem"}
            size={12}
            flex={1}
            justifyContent={"space-between"}
            height={"calc(100% - 6rem)"}
          >
            <CommonGrid2
              display={"flex"}
              flexDirection={"column"}
              gap={"1.5rem"}
              size={7}
            >
              <Grid2 size={10} margin={"2rem auto 0px"}>
                <Typography
                  fontSize={"14px"}
                  fontWeight={500}
                  marginBottom={2}
                  color="#344054"
                >
                  {"Upload Candidates"}
                </Typography>
                <FileUpload
                  onDragOver={handleCandidateDragOver}
                  onDragLeave={handleCandidateDragLeave}
                  onDrop={handleCandidateDrop}
                  onChange={handleCandidateFileUpload}
                  isDragging={isCandidateDragging}
                  files={candidateFiles}
                  handleDeleteFile={handleCandidateDeleteFile}
                  disabled={isLoading}
                />
                <CommonButton
                  width={"100%"}
                  variant="contained"
                  color="white"
                  background="#7F56D9"
                  fontWeight="600"
                  value={
                    candidateFiles.length === 0
                      ? "Upload a Resume"
                      : "Generate Report"
                  }
                  padding={"10px 0px"}
                  onClick={handlResumeUploadClick}
                  disabled={isLoading || candidateFiles.length === 0}
                  loading={isLoading}
                />
                <CommonButton
                  width={"100%"}
                  value={"Skip Demo"}
                  padding={"10px 5rem"}
                  margin={"1.5rem 0px 0px"}
                  fontWeight={"700"}
                  fontSize={"15px"}
                  background={"transparent"}
                  boxShadow={"none"}
                  color="#6941C6"
                  disabled={isLoading}
                  customStyle={{
                    "&:hover": {
                      boxShadow: "none",
                    },
                  }}
                  onClick={() => handleDemoBack("demo", "")}
                />
              </Grid2>
            </CommonGrid2>
            <CommonGrid2
              display={"flex"}
              alignItems={"end"}
              height={"100%"}
              size={5}
              justifyContent={"end"}
              position="relative"
            >
              <HaileyText>
                <Typography fontWeight={700} color="#883FDD">
                  <Typography
                    variant="span"
                    fontWeight={700}
                    fontSize={"18px"}
                    sx={{
                      background:
                        "linear-gradient(98.47deg, #5A35B2 1.87%, #FA4F96 54.6%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Upload a Resume !
                  </Typography>
                </Typography>

                <Typography marginTop={"8px"} fontSize={"15px"}>
                  {candidateFiles.length !== 0
                    ? typedText_generate
                    : typedText_upload_resume}
                </Typography>
              </HaileyText>
              <Haley />
            </CommonGrid2>
          </CommonGrid2>
        </TabPanelView>
        <TabPanelView value={3} padding="0px" height="100%">
          <QuickMatchDemo handleDemoBack={handleDemoBack} />
        </TabPanelView>
      </TabContext>
    </Box>
  );
}
